module.exports = __webpack_public_path__ + "640fb87d02121b040e9bcee401ed3748.pdf";